import React from 'react';

/** Kleiner Hinweis-Banner fuer Schweizer Kunden: Kauf & Zollabwicklung ueber
 *  unseren Partner meineinkauf.ch. */
export default function SwissCustomerNote() {
  return (
    <div style={{ maxWidth: 1200, margin: '0 auto', padding: '0 24px' }}>
      <a
        href="https://meineinkauf.ch/"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="swiss-customer-note"
        style={{
          display: 'flex', alignItems: 'center', gap: 16, textDecoration: 'none',
          background: 'linear-gradient(90deg, #111 0%, #1a0d0d 100%)',
          border: '1px solid #2a2a2a', borderRadius: 14, padding: '16px 22px',
          margin: '12px 0',
        }}
      >
        <SwissFlag />
        <div style={{ flex: 1, minWidth: 0 }}>
          <strong style={{ color: '#fff', fontSize: 16 }}>Für Schweizer Kunden</strong>
          <div style={{ color: '#b8b8b8', fontSize: 14, marginTop: 2 }}>
            Bestelle versandkostenoptimiert &amp; mit einfacher Zollabwicklung über unseren Partner{' '}
            <span style={{ color: '#EC2229', fontWeight: 600 }}>meineinkauf.ch</span>.
          </div>
        </div>
        <span
          style={{
            flexShrink: 0, padding: '9px 18px', background: '#EC2229', color: '#fff',
            borderRadius: 999, fontWeight: 700, fontSize: 14, whiteSpace: 'nowrap',
          }}
          data-testid="swiss-customer-cta"
        >Zu meineinkauf.ch →</span>
      </a>
    </div>
  );
}

function SwissFlag() {
  return (
    <span style={{ flexShrink: 0, width: 40, height: 40, borderRadius: 8, background: '#d52b1e',
      display: 'inline-flex', alignItems: 'center', justifyContent: 'center', position: 'relative' }}
      aria-hidden="true">
      <span style={{ position: 'absolute', width: 22, height: 7, background: '#fff', borderRadius: 1 }} />
      <span style={{ position: 'absolute', width: 7, height: 22, background: '#fff', borderRadius: 1 }} />
    </span>
  );
}
